export default "__VITE_ASSET__BZyrofOX__"